export default __webpack_public_path__ + "static/media/Cashflow-Protection-Plus.637fa9f4.pdf";